import axios from "../util/axios";

export default {
    /** 职员通过密码登录 */
    loginEmployeeByPassword: (user) => axios.post({url: "/basedata/base/loginEmployeeByPassword", data: user}),
    /** 职员通过md5密码登录 */
    loginEmployeeByMd5: (user) => axios.post({url: "/basedata/base/loginEmployeeByMd5", data: user}),
    /** 获取验证码，返回base64 */
    getCheckNumber2: () => axios.get({url: "/basedata/base/getCheckNumber2"}),
    /** 职员通过code扫码登录 */
    loginEmployeeByQywxCode: (code, clientType) => axios.get({url: "/qywx/base/loginByQywxCode", data: {code, clientType}}),
    /** 企业微信自建应用免密登录：code → 职员 → 登录（merchantId 由应用主页地址带上） */
    loginByQywxSelfCode: (merchantId, code, clientType) => axios.get({url: "/wx/base/qywx/app/loginByCode", data: {merchantId, code, clientType}}),
}